import {VarAssignmentChunk} from "../../chunks/types/VarAssignmentChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getVarNameFromVarAssignmentChunk(
  varAssignmentChunk: VarAssignmentChunk
): string {
  const {captures: {1: varNameChunk}} = varAssignmentChunk;
  return getNameFromIdentifierChunk(varNameChunk);
}
